<template>
    <div>
        <el-popover
            placement="left"
            width="200"
            trigger="hover">
            <div class="a-flex-cfsc">
                <div class="dev-qrcode" :id="id"></div>
                <slot></slot>
            </div>
            <span slot="reference">{{ qrVal }}</span>
        </el-popover>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                
            }
        },
        props: {
            qrVal: {
                default: ''
            },
            width: {
                default: 124,
            },
            height: {
                default: 124
            },
            id: {
                default: 'dev-qrcode'
            }
        },
        watch:{
            qrVal:{
                immediate:true,
                handler (val) {
                    if (!val) return
                    this.dialogVisible = true
                    this.$nextTick(()=>{
                        jQuery('#'+this.id).html('')
                        jQuery('#'+this.id).qrcode({
                            render: "canvas",
                            text: val,
                            width: this.width,
                            height: this.height,
                            background: "#ffffff",//背景颜色  
                            foreground: "#000000", //前景颜色
                        });
                    })
                    
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dev-qrcode{
        // width: 148px;
        // height: 148px;
    }
</style>